import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { PromanParametersModule } from '@proman/parameters/proman-parameters.module';
import { PromanFilesManagerComponent } from '@proman/files-manager/proman-files-manager.component';
import { PromanSelectComponent } from '@proman/select';
import { PipesModule } from '@proman/shared/pipes/pipes.module';
import { DragulaModule } from 'ng2-dragula';
import { PromanCommonComponentsModule } from '@proman/common-components/proman-common-components.module';
import { PromanExpressionModule } from '@proman/expression/proman-expression.module';
import { SharedDirectivesModule } from '@proman/shared/directives/shared-directives.module';
import { HtmlTxtComponent } from '@proman/html-txt/html-txt.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FlexLayoutModule,
    DragulaModule.forRoot(),
    PromanSelectComponent,
    PromanCommonComponentsModule,
    PromanExpressionModule,
    SharedDirectivesModule,
    PipesModule,
    PromanFilesManagerComponent,
    PromanParametersModule.forRoot({
      templates: {
        'html': {
          component: HtmlTxtComponent,
        },
      }
    })
  ],
  providers: [],
  exports: [
    PromanParametersModule,
  ]
})

export class MasterParametersModule {}
